<template>
  <div class="form-check margin-top-15">
    <input type="checkbox" class="form-check-input" :id="linkID" :name="checkboxName" :checked="checkboxValue" readonly aria-required="true" aria-label="'Gets checked by clicking the beside button and accepting the license agreement'" role="checkbox" aria-readonly="true"/>
    <label tabindex=0 class="link form-check-label" role="button" data-bs-toggle="modal" :data-bs-target="linkModalID" @click="emitLAClicked()" @keypress.enter="emitLAClicked()">{{linkName}}</label>
  </div>
</template>
<script>
  export default {
    props: ['checkboxName', 'linkName', 'linkID', 'checkboxValue', 'linkModalID'],
    emits: ['licenseAgreementClicked'],
    methods: {
      emitLAClicked() {
        this.$emit("licenseAgreementClicked");
      }
    }
  }
</script>